import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=38fc6f6a"
import script from "./Areas.vue?vue&type=script&lang=ts"
export * from "./Areas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports